type NavigationLocale = typeof import('../en/navigation').default

const navigation = {
	groups: {
		marketing: 'Explorar',
		support: 'Soporte',
		tools: 'Herramientas',
	},
	sidebar: {
		studyPanel: 'Mi biblioteca',
		collections: '{{collectionEntityLabelPlural}}',
		courses: '{{mainEntityLabelPlural}}',
		topics: 'Temas',
		templates: 'Plantillas',
		personalTrail: 'Mi rastro',
		favoriteCourses:
			'{{mainEntityLabelPlural}} favorit{{mainEntityGenderSuffixPlural}}',
		unpinCourse: 'Desanclar {{mainEntityLabelLower}}',
		lastTopics: 'Últimos temas',
		navigation: 'Navegación',
		search: 'Buscar',
		searchPlaceholder: 'Buscar tu contenido',
		support: {
			title: 'Soporte',
			documentation: 'Documentación',
			askForFeature: 'Solicitar una función',
			contactUs: 'Contáctanos',
			tour: 'Ver tour guiado',
			reportBug: {
				title: 'Solicitar ayuda',
				header: 'Enviar solicitud de ayuda',
				emailLabel: 'Email',
				subjectLabel: 'Asunto',
				messageLabel: '¿Cómo puedo ayudarte?',
				receivedRequestMessage:
					'Gracias por ponerte en contacto. Te responderé lo antes posible.',
			},
		},
		settings: 'Ajustes',
		theme: {
			toggle: 'Tema',
			switchToDark: 'Cambiar a modo oscuro',
			switchToLight: 'Cambiar a modo claro',
		},
		logout: {
			title: 'Cerrar sesión',
			dialogTitle: '¿Estás seguro de que quieres cerrar sesión?',
			dialogCancel: 'Cancelar',
			dialogConfirm: 'Continuar',
		},
		profile: 'Perfil',
		user: 'Usuario',
	},
	sidebarAdmin: {
		users: 'Usuarios',
		roles: 'Roles',
		courses: '{{mainEntityLabelPlural}}',
		modules: 'Módulos',
		topics: 'Temas',
		insights: 'Insights',
		configStudio: 'Config Studio',
		emailStudio: 'Email Studio',
		emailSequences: 'Secuencias de email',
		documentation: 'Documentación interna',
	},
	breadcrumb: {
		home: 'Inicio',
		courses: '{{mainEntityLabelPlural}}',
		topics: 'Temas',
		resources: 'Recursos',
		admin: 'Admin',
		dashboard: 'Panel',
	},
	paths: {
		allowedRoles: 'Roles permitidos',
		deniedRoles: 'Roles denegados',
		home: { enabled: 'Inicio', path: 'Ruta de inicio' },
		dashboard: { enabled: 'Panel', path: 'Ruta del panel' },
		auth: {
			login: { enabled: 'Iniciar sesión', path: 'Ruta de login' },
			signup: { enabled: 'Registrarse', path: 'Ruta de registro' },
			forgotPassword: {
				enabled: 'Olvidé contraseña',
				path: 'Ruta de recuperación',
			},
			verify: { enabled: 'Verificar', path: 'Ruta de verificación' },
			onboarding: { enabled: 'Onboarding', path: 'Ruta de onboarding' },
			resetPassword: {
				enabled: 'Restablecer contraseña',
				path: 'Ruta de restablecimiento',
			},
		},
		courses: {
			base: {
				enabled: 'Índice de {{mainEntityLabelPluralLower}}',
				path: 'Ruta de índice de {{mainEntityLabelPluralLower}}',
			},
			detail: {
				enabled:
					'Detalle {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
				path: 'Ruta de detalle {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
			},
			study: {
				enabled:
					'Estudio {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
				path: 'Ruta de estudio',
			},
			project: {
				enabled:
					'Proyecto {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
				path: 'Ruta de proyecto',
			},
			diagram: {
				enabled:
					'Diagrama {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
				path: 'Ruta de diagrama',
			},
			notes: {
				enabled:
					'Notas {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}}',
				path: 'Ruta de notas',
			},
		},
		marketing: {
			courses: { enabled: 'Catálogo', path: 'Ruta del catálogo' },
			courseDetail: {
				enabled: 'Detalle del catálogo',
				path: 'Ruta de detalle del catálogo',
			},
			coursePreview: {
				enabled: 'Vista previa del catálogo',
				path: 'Ruta de vista previa',
			},
		},
		publicCourses: {
			base: {
				enabled:
					'{{mainEntityLabelPlural}} públic{{mainEntityGenderSuffixPlural}}',
				path: 'Ruta de {{mainEntityLabelPluralLower}} públic{{mainEntityGenderSuffixPlural}}',
			},
			detail: {
				enabled:
					'Detalle {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}} públic{{mainEntityGenderSuffix}}',
				path: 'Ruta de detalle público',
			},
			preview: {
				enabled:
					'Vista previa {{mainEntityArticleWithDeLower}} {{mainEntityLabelLower}} públic{{mainEntityGenderSuffix}}',
				path: 'Ruta de vista previa pública',
			},
		},
		admin: {
			users: {
				base: { enabled: 'Usuarios admin', path: 'Ruta de usuarios admin' },
			},
			roles: { base: { enabled: 'Roles admin', path: 'Ruta de roles admin' } },
			courses: {
				base: {
					enabled: '{{mainEntityLabelPlural}} admin',
					path: 'Ruta de {{mainEntityLabelPluralLower}} admin',
				},
			},
			configStudio: {
				base: { enabled: 'Config Studio', path: 'Ruta de Config Studio' },
			},
		},
		static: {
			legal: { enabled: 'Legal', path: 'Ruta legal' },
			blog: { enabled: 'Blog', path: 'Ruta del blog' },
			about: { enabled: 'Acerca de', path: 'Ruta de acerca de' },
			contact: { enabled: 'Contacto', path: 'Ruta de contacto' },
		},
	},
} satisfies NavigationLocale

export default navigation
